/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointmentSlot
 */
export interface AppointmentSlot {
    /**
     * 
     * @type {number}
     * @memberof AppointmentSlot
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof AppointmentSlot
     */
    end?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentSlot
     */
    physicians?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentSlot
     */
    has_follow_up?: boolean;
}

/**
 * Check if a given object implements the AppointmentSlot interface.
 */
export function instanceOfAppointmentSlot(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AppointmentSlotFromJSON(json: any): AppointmentSlot {
    return AppointmentSlotFromJSONTyped(json, false);
}

export function AppointmentSlotFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentSlot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'start': !exists(json, 'start') ? undefined : json['start'],
        'end': !exists(json, 'end') ? undefined : json['end'],
        'physicians': !exists(json, 'physicians') ? undefined : json['physicians'],
        'has_follow_up': !exists(json, 'has_follow_up') ? undefined : json['has_follow_up'],
    };
}

export function AppointmentSlotToJSON(value?: AppointmentSlot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start': value.start,
        'end': value.end,
        'physicians': value.physicians,
        'has_follow_up': value.has_follow_up,
    };
}

